import { Component } from '@angular/core';
import {UserService} from "../../../../services/user.service";
import {PopupService} from "../../../../services/popup.service";
import {environment} from "../../../../../environments/environment";
import {ActivatedRoute, Router} from "@angular/router";
@Component({
  selector: 'app-hubspot',
  templateUrl: './hubspot.component.html',
  styleUrls: ['./hubspot.component.scss']
})
export class HubspotComponent {
  errorMessage = "";

  constructor(
    private routerService: Router,
    private popupService: PopupService,
    private route: ActivatedRoute

  ) {}
  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      if (params['error']) {
        this.popupService.error('Connection Failed',params['error'],'OK');
      }
      else {
        this.popupService.success("", "Hubspot Connected Successfully", 'OK');
      }

        this.routerService.navigate(['/settings/account']);

    });
  }
}
